const $ = jQuery;

// DOM
require("imports-loader?$=>window.jQuery!./boosts/dom.js");

// Persistant storage
require("imports-loader?$=>window.jQuery!./boosts/storage.js");

// Model
require("imports-loader?$=>window.jQuery!./boosts/model.js");

// Controller
require("imports-loader?$=>window.jQuery!./boosts/controller.js");

// View
require("imports-loader?$=>window.jQuery!./boosts/view.js");


// "self-contained" controllers
// ------------------------------------------------------------------------------

// Viewers
require("imports-loader?$=>window.jQuery!./boosts/controller_viewers.js");

// Activity
require("imports-loader?$=>window.jQuery!./boosts/controller_activity.js");



// WEBPACK FOOTER //
// ./src/legacy/boosts.js